module.exports = __webpack_public_path__ + "e17d5ef60470e68732727580920f9972.jpg";